// extracted by mini-css-extract-plugin
module.exports = {"Rating":"Rating_Rating__32Z5c","ReviewsCount":"Rating_ReviewsCount__3Pt3I"};